import { Map, Overlay } from "ol";
import WaypointFeature, { WPT_UNTITLED } from "./WaypointFeature";
import MapBrowserEvent from 'ol/MapBrowserEvent.js';
import OverlayTooltipComponent from "./OverlayTooltipComponent.vue";
import IsWaypointSelectedDelegate from "./IsWaypointSelectedDelegate";
import IsDraggingWaypointDelegate from "./IsDraggingWaypointDelegate";

/*
 * Display "tooltip" popups to display the waypoint name as a "tooltip" on mouseover
 * 
 * see https://stackoverflow.com/questions/35848697/openlayers-3-how-to-make-tootlip-for-feature
 */
export default class WaypointTooltip {
    isWaypointSelectedDelegate: IsWaypointSelectedDelegate
    isDraggingWaypointDelegate: IsDraggingWaypointDelegate

    constructor(isWaypointSelectedDelegate: IsWaypointSelectedDelegate, isDraggingWaypointDelegate: IsDraggingWaypointDelegate) {
        this.isWaypointSelectedDelegate = isWaypointSelectedDelegate
        this.isDraggingWaypointDelegate = isDraggingWaypointDelegate
    }
    
    createElement(waypoint: WaypointFeature): HTMLElement {
        // https://css-tricks.com/creating-vue-js-component-instances-programmatically/
        const tooltipComponent = new OverlayTooltipComponent({
            propsData: { tooltipText: waypoint.props.name}
        })
        tooltipComponent.$mount()
        return tooltipComponent.$el as HTMLElement
    }

    // Create a map overlay to display the tooptip on
    createOverlay(waypoint: WaypointFeature) {
        return new Overlay({
            element: this.createElement(waypoint),
            offset: [0,-65],
            positioning: 'top-center',
        });
    } 

    // Timer ID for dismissing the tooltip after a few seconds
    private timer: NodeJS.Timeout|undefined = undefined

    // Add the tooltip overlay to the given map
    overlay: Overlay|null = null
    addOverlay (waypoint: WaypointFeature, event: MapBrowserEvent<any>) {
        if(this.overlay === null) {
            this.overlay = this.createOverlay(waypoint)
            event.map.addOverlay(this.overlay)
        } else {
            this.overlay.setElement(this.createElement(waypoint))
        }
        this.overlay.setPosition(waypoint.getGeometry().getCoordinates())        
    }
    
    // Display the tooltip for the given waypoint, unless it is currently open in the editor
    // Don't display tooltips for un-labelled waypoints (eg "Untitled3")
    // Automatically dismiss the waypoint after a few seconds
    show (waypoint: WaypointFeature, event: MapBrowserEvent<any>) {
        if (!this.isDraggingWaypointDelegate.isDraggingWaypoint() && !this.isWaypointSelectedDelegate.isWaypointSelected(waypoint) && !waypoint.props.name.startsWith(WPT_UNTITLED)) {
            if(this.timer) clearTimeout(this.timer)
            this.timer = setTimeout(() => this.hide(event.map), 3000)
            this.addOverlay(waypoint, event)
            this.overlay!.setPositioning('top-center')
        }
    }

    // Cancel display of the tooltip
    // If there was a selected waypoint, inhibit display of its tooltip whilst it is being edited
    hide (map: Map) {
        if(this.overlay) {
            map.removeOverlay(this.overlay)
            this.overlay.dispose()
            this.overlay = null
        }
    }

}